import {RecurringStatus} from "../../../../shared/enums/RecurringStatus";
import {EventStatus} from "../../../../shared/enums/eventStatus";
import {parseDuration} from "../../../../utils/dateUtils";
import {personTypeIds} from "../../../../shared/personTypeIds";
import {EventCalendarType} from "../../../../shared/enums/eventCalendarType";
import {IMetricsSummary} from "../../../../utils/metrics/metricTypes";

export class EventMetricsSummary implements IMetricsSummary {
  id: string;
  title: string;
  featured: boolean;
  description: string;
  startDate: Date;
  endDate: Date;
  location?: {
    id?: string;
    name?: string;
  };
  category?: {
    id?: string;
    name?: string;
  };
  price?: {
    amount?: number;
    currency?: string;
  };

  recurringStatus?: RecurringStatus;
  recurrenceFrequency?: string;

  get isRecurring(): boolean {
    return this.recurringStatus !== RecurringStatus.OneOff;
  }

  status: EventStatus;

  capacity?: number;
  capacityRemaining?: number;
  reservedCapacity?: number;
  reservedCapacityRemaining?: number;

  totalBookings?: number;
  totalWaitlistedBookings?: number;
  totalCancelledBookings?: number;
  totalPaidBookings?: number;
  totalConfirmedPayOnAccountBookings?: number;

  bookingDeadline?: {
    weeks?: number;
    days?: number;
    hours?: number;
    minutes?: number;
  };

  villageIds?: string[];
  isMultiVillage: boolean;
  personTypes: string[];

  get calendarTypes(): EventCalendarType[] {
    return this.personTypes.map((personType) => {
      switch (personType) {
        case personTypeIds.independent:
          return EventCalendarType.Enhanced;
        default:
          return EventCalendarType.Engage;
      }
    });
  }

  get isBookable(): boolean {
    // If there is no booking deadline - it is not bookable
    return !!this.bookingDeadline;
  }

  get isEnhanced(): boolean {
    return this.personTypes.includes(personTypeIds.independent);
  }

  get isEngage(): boolean {
    return this.calendarTypes.includes(EventCalendarType.Engage);
  }

  constructor(json: any) {
    this.id = json.id;
    this.title = json.title;
    this.featured = json.featured;
    this.description = json.description;
    this.startDate = new Date(json.startDate);
    this.endDate = new Date(json.endDate);
    this.location = json.location;
    this.category = json.category;
    this.price = json.price;

    this.recurringStatus = json.recurringStatus;
    this.recurrenceFrequency = json.recurrence?.frequency;

    this.status = json.status;
    this.capacity = json.capacity;
    this.capacityRemaining = json.capacityRemaining;
    this.reservedCapacity = json.reservedCapacity;
    this.reservedCapacityRemaining = json.reservedCapacityRemaining;

    this.totalBookings = json.totalBookings;
    this.totalWaitlistedBookings = json.totalWaitlistedBookings;
    this.totalCancelledBookings = json.totalCancelledBookings;
    this.totalPaidBookings = json.totalPaidBookings;
    this.totalConfirmedPayOnAccountBookings =
      json.totalConfirmedPayOnAccountBookings;

    this.bookingDeadline = json.bookingDeadline
      ? parseDuration(json.bookingDeadline)
      : undefined;

    this.villageIds = json.villageIds;
    this.isMultiVillage = json.isMultiVillage;
    this.personTypes = json.personTypes ?? [personTypeIds.independent];
  }
}
